/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type {
  RestrictedVaultFactory,
  RestrictedVaultFactoryInterface,
} from "../../contracts/RestrictedVaultFactory";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "adapterTypeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "adapter",
        type: "address",
      },
    ],
    name: "AdapterCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
    ],
    name: "AdapterTypeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "revoker",
        type: "address",
      },
    ],
    name: "AdapterTypeRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "defaultDepositTolerance",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "setter",
        type: "address",
      },
    ],
    name: "DefaultDepositToleranceSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "feeBps",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "setter",
        type: "address",
      },
    ],
    name: "FeeBpsSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "feeReceiver",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "setter",
        type: "address",
      },
    ],
    name: "FeeReceiverSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "vaultId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "vaultTypeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "adapter",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "vault",
        type: "address",
      },
    ],
    name: "VaultCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "adapter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fixedSideCapacity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "variableSideCapacity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "variableAsset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "feeBps",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "feeReceiver",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "vault",
        type: "address",
      },
    ],
    name: "VaultInitialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
    ],
    name: "VaultTypeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "revoker",
        type: "address",
      },
    ],
    name: "VaultTypeRevoked",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "adapterTypeByteCode",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "bytecode",
        type: "bytes",
      },
    ],
    name: "addAdapterType",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "bytecode",
        type: "bytes",
      },
    ],
    name: "addVaultType",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_adapterType",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_base",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "createAdapter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_vaultType",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_adapter",
        type: "address",
      },
    ],
    name: "createVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultDepositTolerance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "deployedAdapterAddrToId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "deployedAdapterInfo",
    outputs: [
      {
        internalType: "uint256",
        name: "adapterTypeId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "creatorAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeBps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vaultId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "fixedSideCapacity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "variableSideCapacity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "variableAsset",
        type: "address",
      },
    ],
    name: "initializeVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nextAdapterTypeId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextDeployedAdapterId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextVaultId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextVaultTypeId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "revokeAdapterType",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "revokeVaultType",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_defaultDepositTolerance",
        type: "uint256",
      },
    ],
    name: "setDefaultDepositTolerance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_feeBps",
        type: "uint256",
      },
    ],
    name: "setFeeBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_feeReceiver",
        type: "address",
      },
    ],
    name: "setFeeReceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "vaultAddrToId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "vaultInfo",
    outputs: [
      {
        internalType: "address",
        name: "creatorAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "address",
        name: "adapterAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "vaultTypeId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "vaultTypeByteCode",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "wasDeployedByFactory",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type RestrictedVaultFactoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RestrictedVaultFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class RestrictedVaultFactory__factory extends ContractFactory {
  constructor(...args: RestrictedVaultFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<RestrictedVaultFactory> {
    return super.deploy(overrides || {}) as Promise<RestrictedVaultFactory>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): RestrictedVaultFactory {
    return super.attach(address) as RestrictedVaultFactory;
  }
  override connect(signer: Signer): RestrictedVaultFactory__factory {
    return super.connect(signer) as RestrictedVaultFactory__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RestrictedVaultFactoryInterface {
    return new utils.Interface(_abi) as RestrictedVaultFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RestrictedVaultFactory {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as RestrictedVaultFactory;
  }
}
